import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'shared-portal-components-v2';

export interface SortOptionItem {
  key: string;
  label: string;
}

export interface SixDashboardSortSelectProps {
  value: string | undefined;
  sortOptions: SortOptionItem[];
  onChange: (nextValue: string) => void;
}

export function SixDashboardSortSelect({ value, sortOptions, onChange }: SixDashboardSortSelectProps): React.JSX.Element {
  const selectedOption = sortOptions.find((option) => option.key === value);

  return (
    <Select value={value} onValueChange={onChange} disabled={false}>
      <SelectTrigger className="w-[140px]">
        <SelectValue placeholder={sortOptions[0]?.label ?? 'Sort by'}>
          {selectedOption?.label}
        </SelectValue>
        <ChevronDown className="h-4 w-4 text-muted-foreground" aria-hidden />
      </SelectTrigger>
      <SelectContent>
        {sortOptions.map((option) => (
          <SelectItem key={option.key} value={option.key}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default SixDashboardSortSelect;
